<div class="my-9">
  <h2 class="h2">{{ 'habaCheckoutProgress.login' | cxTranslate }}</h2>
</div>
<app-login-form [isCheckoutLogin]="true" [redirectAfterLogin]="redirectAfterLogin"></app-login-form>
